<ng-container *transloco="let t">
  <span class="header__title">{{ title() || t(ts.supportTitle) }}</span>

  <div class="header__actions">
    @if (showHistoryButton()) {
      <button
        type="button"
        class="header__iconbtn header__iconbtn--history"
        data-test="report chat history"
        [attr.aria-label]="historyAriaLabel() || t(ts.historyAria)"
        (click)="historyClick.emit()"
      >
        <ds-icon-paragraph-bullet-list size="s"></ds-icon-paragraph-bullet-list>
        @if (hasUnread()) {
          <span class="header__dot" aria-hidden="true"></span>
        }
      </button>
    }
    <button
      type="button"
      class="header__iconbtn header__iconbtn--close"
      data-test="report chat close"
      [attr.aria-label]="closeAriaLabel() || t(ts.closeAria)"
      (click)="closeClick.emit()"
    >
      <ds-icon-close size="s"></ds-icon-close>
    </button>
  </div>
</ng-container>
